import { BaseModel } from "model/BaseModel";
import Produto from "model/administracao/cadastro/produto/Produto";
import EstagioOP from "./EstagioOP";
import ComponenteOP from "./ComponenteOP";
import ItemPedido from "./ItemPedido";
import ExecucaoPlanoQualidade from "model/qualidade/ExecucaoPlanoQualidade";
import Usuario from "model/administracao/cadastro/Usuario";

export default class OrdemProducao implements BaseModel {
    id: number;
    codigo: string | null = "";
	numero: number;
    lote: string;
	produto: Produto;
	qtPrevista: number;
	qtProduzida: number;
    dataInicio: Date | null = null;
    dataFim: Date | null = null;
    dataGeracao: Date | null = null;
    dataValidade: Date | null = null;
	status: string;
    estagiosOp: EstagioOP[];
    componentesOp: ComponenteOP[];
    itemPedido: ItemPedido | null;
    execucaoPlanoQualidade: ExecucaoPlanoQualidade| null;
    usuarioGeracao: Usuario | null;

    constructor(
        id: number = 0,
        numero: number = 0,
        lote: string = "",
        produto: Produto = new Produto(),
        qtPrevista: number = 0,
        qtProduzida: number = 0,
        dataInicio: Date | null = null,
        dataFim: Date | null = null,
        dataGeracao: Date | null = null,
        dataValidade: Date | null = null,
        status: string = "GERADA",
        estagiosOp: EstagioOP[] = [],
        componentesOp: ComponenteOP[] = [],
        itemPedido: ItemPedido = new ItemPedido(),
        execucaoPlanoQualidade = null,
        usuarioGeracao = null
    ) {
        this.id = id;
        this.numero = numero;
        this.lote = lote;
        this.produto = produto;
        this.qtPrevista = qtPrevista;
        this.qtProduzida = qtProduzida;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.dataGeracao = dataGeracao;
        this.dataValidade = dataValidade;
        this.status = status;
        this.estagiosOp = estagiosOp;
        this.componentesOp = componentesOp;
        this.itemPedido = itemPedido;
        this.execucaoPlanoQualidade = execucaoPlanoQualidade;
        this.usuarioGeracao = usuarioGeracao;
    }
}